<template>
  <div class="retouching-sidebar-cta-buttons">
    <div class="row">
      <div class="col-xs-3 col-sm-6 price-column">
        <h3 class="price">+{{ retouchingPackage.EffectiveCostFormatted }}</h3>
      </div>
      <div class="col-xs-5 col-sm-6 button-column">
        <div v-if="!packageAlreadyInCart">
          <button
            v-if="!packageSelected"
            class="button retouchings__item-button"
            type="button"
            @click="handleRetouchingAddClick"
          >
            <i class="fa fa-plus"/>
            <contentful-text :item="contentfulText('label-add')"/>
          </button>
          <button
            v-if="packageSelected"
            class="button retouchings__item-button"
            type="button"
            @click="handleRetouchingRemoveClick"
          >
            <i class="fa fa-times"/>
            <contentful-text :item="contentfulText('label-remove')"/>
          </button>
        </div>
        <div
          v-if="packageAlreadyInCart"
          class="retouchings__item-already-in-cart"
        >
          <div class="retouchings__item-added-label">
            <contentful-text :item="contentfulText('label-already-in-cart')"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContentfulMixin from '@Shared/mixins/contentful'
import _ from 'lodash'
import GoogleAnalytics from '@Shared/lib/google-analytics'

export default {
  name: 'SidebarCtaButtons',
  mixins: [ContentfulMixin],
  props: {
    retouchingPackage: { type: Object, default: null },
    selectedRetouchings: { type: Array, default: null },
    retouchingsInCart: { type: Object, default: null },
    frameId: { type: Number, default: null },
    content: { type: Object, default: null }
  },
  computed: {
    packageSelected () {
      return _.some(this.selectedRetouchings, {
        frameId: this.frameId,
        offerPackageId: this.retouchingPackage.OfferPackageID
      })
    },
    packageAlreadyInCart () {
      if (_.has(this.retouchingsInCart, this.frameId)) {
        return (
          this.retouchingsInCart[this.frameId].indexOf(
            this.retouchingPackage.OfferPackageID
          ) > -1
        )
      } else {
        return false
      }
    }
  },
  methods: {
    handleRetouchingAddClick () {
      this.$emit('retouching-added')

      GoogleAnalytics.trackEvent('Proof', 'Retouching Added', this.retouchingPackage.CatalogPackage.RetailName)
    },
    handleRetouchingRemoveClick () {
      this.$emit('retouching-removed')

      GoogleAnalytics.trackEvent('Proof', 'Retouching Removed', this.retouchingPackage.CatalogPackage.RetailName)
    }
  }
}
</script>

<style lang="scss" scoped>
.retouching-sidebar-cta-buttons {
  margin-bottom: 20px;

  .price-column {
    text-align: left;
  }

  .button-column {
    text-align: left;
  }

  .price {
    font-weight: 800;
    margin-top: 10px;
    font-family: $font-roboto;
  }

  & .retouchings__item-button {
    height: auto;
    line-height: inherit;
    padding: 10px 20px;
    border: 2px solid $grad-color-blue;
    color: $grad-color-blue;
    background-color: #fff;
    width: 100%;
    text-align: center;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;

    &:hover {
      outline: 4px solid $grad-color-blue;
      outline-offset: -2px;
      text-decoration: none;
    }
  }

  @media screen and (min-width: $screen-sm-min) {
    margin-bottom: 0;

    .price {
      margin-top: 14px;
    }
  }
}

@media screen and (min-width: $screen-sm-min) {
  .retouchings__item-already-in-cart {
    margin-top: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/shared/components/catalog/RetouchingModal/SidebarCtaButtons.vue